<template>
  <div class="PresentPersonelListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      @click:row="handleClick"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 50, 100, -1],
        'items-per-page-text': $t('rowsPerPage'),
        'show-first-last-page': true,
      }"
      :item-class="getItemBackColor"
    >
      <template v-slot:item.AbsentType="{ item }">
        <span>
          {{ getAbsentType(item.AbsentType) }}
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      selectedList: [],
      headers: [
        {
          text: this.$t("card-no"),
          value: "PERNO",
        },
        {
          text: this.$t("person-name"),
          value: "personName",
        },
        {
          text: this.$t("SectionName"),
          value: "sectionName",
        },
        {
          text: this.$t("AbsentType"),
          value: "AbsentType",
        },
      ],
    };
  },
  methods: {
    getAbsentType(AbsentType) {
      switch (AbsentType.toString()) {
        case "0":
          return "غیبت";
        case "1":
          return "مرخصی روزانه";
        case "2":
          return "ماموریت روزانه";
        case "3":
          return "مرخصی ساعتی";
        case "4":
          return "ماموریت ساعتی";
        case "5":
          return "تاخیر سرویس";
        default:
          return "غیبت";
      }
    },
    getItemBackColor(item) {
      if (this.getAbsentType(item.AbsentType) == "غیبت") {
        return "bg-red";
      }
      return "";
    },
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style>
</style>